import { FRONTEND_DOMAIN } from "../config/config";

const getEffectiveDomain = () => {
    let domain = FRONTEND_DOMAIN;
    if (typeof window !== "undefined") {
        if (!domain || domain.includes("localhost") || domain.includes("127.0.0.1")) {
            if (!window.location.hostname.includes("localhost") && !window.location.hostname.includes("127.0.0.1")) {
                domain = window.location.origin;
            } else {
                domain = "https://ehospitalitynepal.com";
            }
        }
    }
    return domain || "https://ehospitalitynepal.com";
};

export const getQRMenuLink = (code) => {
    return `${getEffectiveDomain()}/m/${code}`;
}

export const getTableQRMenuLink = (code, tableId) => {
    return `${getEffectiveDomain()}/m/${code}?table=${tableId}`;
}

export const getRoomQRMenuLink = (code, roomName) => {
    return `${getEffectiveDomain()}/m/${code}?room=${encodeURIComponent(roomName)}`;
}
